import React, { useEffect } from "react";
import { Button } from "../../components";
import { useNavigate } from "react-router-dom";

const CameraRight = ({
  hasCameraPermission,
  sethasCameraPermission,
  step,
  setStep,
}) => {
  const navigate = useNavigate();
  useEffect(() => {
    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then(() => {
        sethasCameraPermission(true);
      })
      .catch((err) => {
        console.log(err);
        sethasCameraPermission(false);
        // askForCameraPermission()
      });
  }, [step, sethasCameraPermission]);

  return (
    <div className="flex flex-col items-start justify-between h-full w-[80%] mx-auto my-2">
      <div className="flex flex-col">
        <h1 className="heading1 mb-8">
          Webcam Mandatory while giving Assessment Test
        </h1>
        <ul className="gap-4 text-[#919397] listDisc">
          <li>Always keep the Camera ON and working during the assessment.</li>
          <li>
            Please do not leave your Laptop/PC while the test is going on.
          </li>
          <li>
            Please sit in front of proper lighting so that the camera can detect
            your face and background.
          </li>
          <li>
            The test will get terminated if the webcam is turned off at any time
            while giving the test.
          </li>
        </ul>
      </div>
      <Button
        version="primary"
        text="Proceed"
        handleClick={() => {
          setStep((prev) => prev + 1);
        }}
        width="fit-content"
        isDisabled={!hasCameraPermission}
      />
    </div>
  );
};

export default CameraRight;
